import { Injectable } from '@angular/core';

import { BaseEditCopyService } from 'tms-lib';

@Injectable({
  providedIn: 'root',
})
export abstract class TmsWebBaseEditCopyService<T, TEdit> extends BaseEditCopyService<T, TEdit> {
  protected constructor(baseRoute: string, name: string) {
    super(baseRoute, name);
  }

  protected get apiUrl() {
    return `TmsWeb/${this.baseRoute}`;
  }
}
